import React from "react";
import { DashboardLayout } from "@/components/dashboard/dashboard-layout";
import { SuppliesList } from "./SuppliesList";

const SuppliesPage = () => {
  return (
    <DashboardLayout>
      <SuppliesList />
    </DashboardLayout>
  );
};

export default SuppliesPage;
